import React from 'react';
import { Button } from 'react-bootstrap';
import './StatePanel.css';

const formatNumber = (num) => {
  return new Intl.NumberFormat('pt-BR').format(num);
};

const formatPercent = (num) => {
  return num.toFixed(2).replace('.', ',') + '%';
};

const StatePanel = ({ data, onClose, darkMode }) => {
  if (!data) return null;

  const title = data.sigla ? `${data.estado} (${data.sigla})` : data.estado;
  const country = data.pais || null;

  return (
    <div className={`state-panel ${darkMode ? 'dark' : 'light'} slide-in`}>
      <div className="state-panel-header">
        <div>
          <h4>{title}</h4>
          {country && <small>{country}</small>}
        </div>
        <Button
          variant={darkMode ? 'dark' : 'light'}
          className="close-button"
          onClick={onClose}
          aria-label="Fechar"
        >
          <i className="bi bi-x-lg"></i>
        </Button>
      </div>

      <div className="state-panel-content">
        <div className="state-panel-summary">
          <div className="summary-card">
            <h5>Total de Medições</h5>
            <div className="summary-value">{formatNumber(data.totalMeasurements)}</div>
          </div>
        </div>

        <div className="state-panel-grains">
          {Object.entries(data.grainAverages).map(([grain, values]) => (
            <div key={grain} className="grain-card fade-in">
              <h6>{grain}</h6>
              <div className="grain-stats">
                <div className="stat">
                  <span>Umidade Média:</span>
                  <strong>{formatPercent(values.humidity)}</strong>
                </div>
                <div className="stat">
                  <span>Medições:</span>
                  <strong>{formatNumber(values.count)}</strong>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="panel-footer">
        <Button 
          variant="outline-secondary" 
          className="w-100"
          onClick={onClose}
        >
          Fechar
        </Button>
      </div>
    </div>
  );
};

export default StatePanel;
